import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { DLPPolicy } from "./DLPPolicy";

export const DLPLocalOcrMode = Type.Union([Type.Literal("off"), Type.Literal("shadow"), Type.Literal("on")]);
export type DLPLocalOcrMode = TypeBoxToType<typeof DLPLocalOcrMode>;

// Pushed server-side because the client only holds rule references ({type:"rule", id}), never
// rule bodies — the rule-shape flags below are computed where the rule bodies live.
export const DLPLocalOcrSettings = Type.Object({
  mode: DLPLocalOcrMode,
  hasChecksumIdRules: Type.Boolean(),
  hasFileInspectingRules: Type.Boolean(),
  // Server-pushed so tuning them never needs a desktop release; org configs back them.
  confidenceFloor: Type.Optional(Type.Number()),
  canaryRate: Type.Optional(Type.Number()),
});
export type DLPLocalOcrSettings = TypeBoxToType<typeof DLPLocalOcrSettings>;

export const DLPSettings = Type.Object({
  policies: Type.Array(DLPPolicy),
  allow_dlp_ai: Type.Boolean(),
  hasDlpDetector: Type.Boolean(),
  internalPhones: Type.Optional(Type.Array(Type.String())),
  localOcr: Type.Optional(DLPLocalOcrSettings),
});
export type DLPSettings = TypeBoxToType<typeof DLPSettings>;
